<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'lg'"
    :centered="false"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CInput
          type="number"
          label="Monto de apertura"
          v-model="process.initial"
          :disabled="!newBead"
          @keyup="validatePositive('monto')"
        />
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CInput
          type="text"
          label="Observación"
          v-model="process.observation"
        />
      </CCol>
    </CRow>
    <template #footer>
      <button @click="mtdClose" class="btn btn-sm btn-danger">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="mtd_action" class="btn btn-info btn-sm"><i class="fas fa-comment-dollar"></i> Aperturar</button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
export default {
  name: "c-open-bead-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "beads",
      bead: {
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        expense: "",
        income: "",
        turned: "",
        card: "",
        retirement: "",
        status_open: "",
        status_close: "",
        deposit: "",
        authorize: "",
        state: "",
      },
      process: {
        box_id: "",
        observation: "",
        initial: 0,
      },
      newBead: true,
      /** arqueo */
      billetes: [],
      monedas: [],
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal == true) {
        this.filterBox();
      }
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.resetFormData();
      this.$emit("closeModalOpenBead");
    },
    resetFormData() {
      this.bead = {
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        status_open: "",
        status_close: "",
        state: "",
      };
    },
    mtd_action() {
      this.process.billetes=this.billetes;
      this.process.monedas=this.monedas;
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          bead: this.bead,
          process: this.process,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            let color = "success";
            let message = "REGISTRADO CORRECTAMENTE";
            // Reseteamos la data
            this.resetFormData();
            this.$emit("save");
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    filterBox() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/filterBox/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let box = response.data.data;
          this.newBead = response.data.new;
          this.process.box_id = box.id;
          this.bead.box_id = box.id;
          /** last bead */
          let jsonCierre = JSON.parse(
            response.data.lastBead.transaction.json_cierre
          );
          this.billetes = jsonCierre.billetes;
          this.monedas = jsonCierre.monedas;
          this.process.initial = response.data.initialPrevious;
        })
        .catch((erros) => {});
    },
    validatePositive(field) {
      let sanitizedValue = event.target.value.replace(/[^0-9.]/g, "");
      const decimalCount = sanitizedValue.split(".").length - 1;
      if (decimalCount > 1) {
        sanitizedValue = sanitizedValue.slice(0, -1);
      }
      const decimalIndex = sanitizedValue.indexOf("."); // Limitar a dos decimales
      if (decimalIndex !== -1) {
        const decimalPart = sanitizedValue.substring(decimalIndex + 1);
        sanitizedValue = `${sanitizedValue.substring(
          0,
          decimalIndex
        )}.${decimalPart.substring(0, 2)}`;
      }
      this.bead[field] = sanitizedValue;
    },
  },
};
</script>

<style scoped>
</style>
